import React, { useEffect, useState } from "react";
import CardLoading from "../../../../components/CardLoading";
import { fetchData } from "../../../../features/dropdown/dropdownSlice";
import { Checkbox, Divider, Dropdown, Table, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Search from "../../../../components/Search";
import svg102 from "../../../../assets/svg/svg102.svg";
import useModalToggle from "../../../../custom_hooks/useModalToggle";
import ConfirmModal from "../../../../components/ConfirmModal";
import ProfileView from "./ProfileView";
import { formatText } from "../../../../utils";

function Recommendation() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
   const url = "v1/ap/recommendations";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.dropdown.loading,
    data: state.dropdown.data[url] || [],
    count: state.dropdown.count[url] || 0,
  }));

  const { open, handleCancel, handleOpen } = useModalToggle();
  const { refetchKey } = useSelector((state) => state.folder);

  const showDrawer = () => {
    handleOpen();
  };
  const onClose = () => {
    handleCancel();
  };

  const [openDelete, setOpenDelete] = useState(false);
  const { saving } = useSelector((state) => state.save);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    // const res = await dispatch(
    //   save({
    //     url: "evaluation/delete_evaluation",
    //     evaId: prodd?.evaId,
    //   })
    // );
    // if (res?.payload?.success) {
    //   await toast.success(res?.payload?.message);
    //   setOpenDelete(false);
    //   await fetchTableData();
    // } else {
    //   toast.error(res?.payload?.message);
    // }
  };

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        japFirstName: e.target.value == "" ? null : e.target.value,
      })
    );
  };

  const plainOptions = ["Published", "Re-advertised", "Archived", "Cancelled"];
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [popoverVisible, setPopoverVisible] = useState(false);

  const handleRemoveFilter = (removedStatus) => (e) => {
    console.log("clicked");
    e.preventDefault();
    setSelectedFilters((prev) =>
      prev?.filter((status) => status !== removedStatus)
    );
  };
  const onChangeFilter = (checkedValues) => {
    setSelectedFilters(checkedValues);
  };

  const handleApply = async () => {
    await setPopoverVisible(false);
    console.log("Apply filters:", selectedFilters);
  };

  const handleReset = async () => {
    await setSelectedFilters([]);
    await setPopoverVisible(false);
  };
  const filterOverlay = (
    <div className="w-[15.6875rem] p-[1.5rem] bg-white rounded-[.5rem] shadow-[0_0_13.9px_0_rgba(0,0,0,0.08)]">
      <p className="font-semibold">Select Filter</p>
      <Checkbox.Group
        options={plainOptions}
        value={selectedFilters}
        onChange={onChangeFilter}
        className="filter-checkbox"
      />

      <Divider />

      <div className="flex justify-center gap-[1.5rem] mt-3 font-dmSans text-[.875rem] font-[400]">
        <span className="text-[#FDB505]  cursor-pointer" onClick={handleReset}>
          Reset
        </span>
        <span className="text-[#C62130]  cursor-pointer" onClick={handleApply}>
          Apply
        </span>
      </div>
    </div>
  );

  const handleViewName = async (item) => {
    await setProdd(item);
    await showDrawer();
  };
  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: "5%",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Candidate",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.japFirstName} {item?.japLastName}
          </div>
        );
      },
    },
    {
      title: "Match Score",
      dataIndex: "japMatchingScore",
      render: (item) => {
        return (
          <div className="py-[.25rem] px-[.5rem] flex items-center justify-center gap-[.625rem] rounded-[.25rem] bg-[#569D6E] opacity-[0.8]">
            {item}
          </div>
        );
      },
    },
    {
      title: "Progress Status",
      dataIndex: "japProgressStatus",
      render: (item) => {
        const colors = {
          DRAFT: "#706F6F",
          SHORTLIST: "#FDB505",
          SCHEDULE_INTERVIEW: "#DAA520",
          OFFER: "#569D6E",
          HIRE: "#569D6E",
          DROP: "#C62130",
        };

        return (
          <div
            className="bg-[#E8EEED] inline-block rounded-[8px] px-[1rem] py-[.25rem] w-auto !font-[500] !text-[1rem]"
            style={{
              color: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },
    // {
    //   title: "Actions",
    //   render: (item) => (
    //     <>
    //       <button
    //         type="button"
    //         className="cstm-btn-2 !w-[200px]"
    //         onClick={handleOpenDelete}
    //       >
    //         Recommend
    //       </button>
    //     </>
    //   ),
    // },
  ];
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    if (refetchKey == 3) {
      fetchTableData();
    }
  }, [refetchKey]);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <>
      <div className="flex items-center gap-[1rem]">
        <div className="lg:w-[35.125rem] w-auto ">
          <Search
            searchInput={searchInput}
            handleSearch={handleSearch}
            text={"Search ..."}
          />
        </div>
      </div>

      <div className="flex items-center text-[#706F6F] text-[.875rem] font-dmSans font-[400] mt-[1.5rem] gap-[.5rem]">
        <img src={svg102} alt="svg102" /> Candidates must have a scrore of more
        than 60% to be recommended
      </div>

      <Table
        rowSelection={false}
        className="mt-[1.5rem] w-full"
        scroll={{
          x: "auto",
        }}
        rowKey={(record) => record?.damId}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          position: ["bottomRight"],
          current: pageIndex + 1,
          total: count,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPageIndex(page - 1);
            setPageSize(size);
            fetchTableData(page - 1, size);
          },
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
      />
      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={saving}
        content="Confirm action: Are you sure you want to recommend this candidate?"
        type="info"
        btnTitle="Confirm"
      />
      <ProfileView
        onClose={onClose}
        openDrawer={open}
        prodd={prodd}
        action={false}
      />
    </>
  );
}

export default Recommendation;
